<template>
  <div id="uploader">
    <div v-if="isMobile">
      <div id="uploader">
        <div class="bj disflex">
          <div class="waitCheck" v-if="isResult">
            <img src="@/assets/mobileworkflow/check.png" alt="">
            待审核:
            <span>{{allPicCount}}</span>
            张
          </div>
          <div class="waitCheck" v-if="!isResult">
            <!-- <img src="@/assets/mobileworkflow/check.png" alt=""> -->
            最终选入:
            <span>{{resultCount}}</span>
            张
          </div>
          <div style="display:none;" class="disflex" >
            <img style="width:4.6vw;" src="@/assets/uploader/clock.png" alt />
            <p>{{hour + ' : ' + minute + ' : ' + second}}</p>
          </div>
        </div>
        
        <div class="steps">
            <div class="stepsbj">
              <div class="ybj">
                <p>1</p>
              </div>
              <!-- <img  src="@/assets/sreenpic/yellow.png" alt=""> -->
              <span>初选</span>
            </div>
            <div class="xian" style="border-bottom: 2px dashed #FE8E24;"></div>
            <div class="stepsbj">
              <div class="ybj">
                <p>2</p>
              </div>
              <span>复审</span>
            </div>
            <div class="xian" :style="{'borderBottom': !isResult?'2px dashed #FE8E24':'2px dashed #185ED3'}"></div>
            <div class="stepsbj">
           
              <div v-if="isResult" class="bbj" >
                <p>3</p>
              </div>
              <div v-if="!isResult" class="bbj abj" >
                <p>3</p>
              </div>
              <span :style="!isResult?'color:#FE8E24;':'color:#185ED3;'">筛选结果</span>
            </div>
        </div>

        <template v-if="isResult">
          <div>
            <div class="picList" ref="nr" @scroll.passive="getscroll($event)">
              <section>
                <div v-for="(item,index) in picList" :key="index" class="img-wrapper" >
                  <!-- <img src="@/assets/vs_back.jpg" alt=""> -->
                  <!-- <img class="img" :src="item.src" alt="" @click="choosePic(item)"> -->
                  <div 
                    class="img" 
                    :style="'background: url('+item.src+')  no-repeat center top;background-size: 100% 100%;'"
                    @click="choosePic(item)"
                    ></div>
                  <div class="backg">
                    <van-icon class="img1" name="search"  @click="browsePic(item)"/>
                    <!-- <img class="img1" src="@/assets/mobileworkflow/see.png" alt="" @click="browsePic(item)"> -->
                  </div>
                  <div v-if="item.isCheck == 1"
                  class="imgchoose"
                  :style="item.isCheck==1?'border: 1vw solid #185ED3':'border: none'"
                  @click="deletePic(item)">
                        <!-- <img src="@/assets/sreenpic/choose.png" alt /> -->
                        <span >{{item.chooseNumber}}</span>
                  </div>
                  
                </div>
              </section>
              <!-- <p @click="seeMore" style="text-align:center;margin:2.667vw auto;font-size:2.667vw;color:grey;">{{srcollText}}</p> -->
            </div>
            <div class="btnStyle">
              <van-button :disabled="isTimeOut" @click="savePic" round class="btn" type="info" color="#185ED3">保存</van-button>
              <van-button :disabled="isTimeOut" @click="savePic1" round class="btn" type="info" color="#185ED3">保存并结束</van-button>
            
            </div>
            <van-image-preview v-model="show" :images="images"  :startPosition="index">
              <!-- <template v-slot:index>第{{ index }}页</template> -->
            </van-image-preview>
          </div>
        </template>
        <template v-if="!isResult">
          <div>
            <div class="picList" ref="nr" @scroll.passive="getscroll($event)">
              <section>
                <div v-for="(item,index) in resultList" :key="index" class="img-wrapper" >
                  <!-- <img src="@/assets/vs_back.jpg" alt=""> -->
                  <!-- <img class="img" :src="item.src" alt="" > -->
                  <div 
                    class="img" 
                    :style="'background: url('+item.src+')  no-repeat center top;background-size: 100% 100%;'"
                    ></div>
                  <div class="backg">
                    <img class="img1" src="@/assets/mobileworkflow/see.png" alt="" @click="browsePic1(item)">
                  </div>
                  
                </div>
              </section>
            </div>
            <!-- <p @click="seeMoreResult" style="text-align:center;margin:2.667vw auto;font-size:2.667vw;color:grey;">{{srcollTextResult}}</p> -->
          </div>
          <van-image-preview v-model="show" :images="images1"  :startPosition="index1">
        <!-- <template v-slot:index>第{{ index }}页</template> -->
          </van-image-preview>
        </template>
      </div>
      
      
      <!-- <van-dialog v-model="showdialog" title="确认保存图片吗" show-cancel-button>
        
      </van-dialog> -->
    </div>
    <div v-if="!isMobile">
      <p>请您使用手机访问</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate,formatConversion } from "@/plugins/getdate";
import { myPowers } from "@/api/userCenter";
import { listLib } from '@/api/lib'

import { Dialog,Notify  } from 'vant';

import {
  checkPictures,
  selectPicture,
  listSelect,
  listCheck,
  unSelectPicture,
  addMessage,
  listMessage,
  rejectPictureArticle,
  listArticle,
  getTask,
  setTaskStatus
} from "@/api/workflow";
import { picPrefix } from "@/constants/piccommon";

export default {
  data() {
    return {
      picPrefix,
      // srcollText:'点击加载更多',
      // srcollTextResult: '点击加载更多',
      isMobile: true,
      isTime: true,
      hour: "00",
      minutes: 29,
      seconds: 59,
      picList:[],
      resultList:[],
      show: false,
      index: 1,
      index1: 1,
      images: [],
      images1:[],
      allPicCount: 0,
      chooseNumber: 1,
      chooseArr: [],
      chooseNum: 0,
      isResult: true,
      isTimeOut: false,
      currentPageAct: 1,
      currentPageCheck:1,
      resultCount: 0,
      scrollDown: true,
      flag: true,
      chooseNumberFlag: 1,
    };
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal);
      }
    },
    minute: {
      handler(newVal) {
        this.num(newVal);
      }
    }
  },
  computed: {
    second: function() {
      return this.num(this.seconds);
    },
    minute: function() {
      return this.num(this.minutes);
    }
  },
  methods: {
    ...mapActions(["setToken"]),
    ...mapActions(["setCreateUid"]),
    beforeDelete(){},
    afterRead(){},
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getscroll(e) {
      // console.log(
      // // "pageYOffset "+this.$refs.nr.pageYOffset,
      // "offsetHeight "+this.$refs.nr.offsetHeight,
      // "offsetTop "+this.$refs.nr.offsetTop,
      // "offsetWidth "+this.$refs.nr.offsetWidth,
      // "scrollHeight "+this.$refs.nr.scrollHeight,
      // "scrollTop "+this.$refs.nr.scrollTop,
      // "scrollWidth "+this.$refs.nr.scrollWidth,
      // "clientHeight "+this.$refs.nr.clientHeight
      // );
     
      if(this.picList.length !== this.allPicCount || this.resultList.length !== this.resultCount){
        // console.log(e)
        // console.log(this.$refs.nr.scrollTop, this.$refs.nr.offsetTop)
        if( this.$refs.nr.offsetHeight + 100 + this.$refs.nr.scrollTop >= this.$refs.nr.scrollHeight && this.flag){
          console.log('到底了');
          this.flag = false
          if(this.isResult){
            this.seeMore()
          }else{
            this.seeMoreResult()
          }
        }
      }
    },
    seeMore(){
      // this.srcollText = "正在加载中……"
      if (this.allPicCount !== this.picList.length) {
        // console.log(this.allPicCount,this.picList.length)
        this.currentPageAct++;
        let dataActList = {page:(this.currentPageAct - 1),pageSize: 14,pictureArticleFilterTaskId :this.$route.query.id }
        this.getPicList(dataActList)
        // this.srcollText = '点击加载更多'
      }else{
        // this.srcollText = '已加载全部'
      }
      setTimeout(()=>{
        this.flag = true
      },600)
    },
    seeMoreResult(){
      // this.srcollTextResult = "正在加载中……"
      if (this.resultCount !== this.resultList.length) {
        // console.log(this.allPicCount,this.picList.length)
        this.currentPageCheck++;
        let dataActList = {page:(this.currentPageCheck - 1),pageSize: 14,pictureArticleFilterTaskId :this.$route.query.id }
        this.listCheckAsync(dataActList)
        // this.srcollTextResult = '点击加载更多'
      }else{
        // this.srcollTextResult = '已加载全部'
      }
      setTimeout(()=>{
        this.flag = true
      },600)
    },

    num(n) {
      return n < 10 ? "0" + n : "" + n;
    },

    transTime(time) {
      if (time === "") {
        return "";
      } else {
        var result = "";
        if (time >= 1000) {
          var day = parseInt(time / (24 * 60 * 60 * 1000));
          var hour = parseInt(
            (time % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
          );
          var minute = parseInt(
            ((time % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) / (60 * 1000)
          );
          var second = parseInt(
            (((time % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) %
              (60 * 1000)) /
              1000
          );
          // if (day != 0) {
          //   result += day + "天";
          // }
          // if (hour != 0) {
          //   result += hour + "时";
          // }
          this.minutes = minute
          this.seconds = second
          // console.log(second)
          // if (minute < 10) {
          //   result = '00:' + '0' + minute + ":" + second;
            
          // }
          // if(second < 10){
          //   result = '00:' + '0' + minute + ":" + '0' + second;
            
          // }
          // if (second != 0) {
          //   result += second;
          // }
          // console.log(result)
          if (minute === 0 && second === 0) {
            // this.$router.push({ name: 'timeout'})
            Notify({ type: 'warning', message: '时间到！' });
            this.isTimeOut = true
            // Toast('上传时间已到');
          }
        }
        // return result
        // this.zjytime = result
      }
    },

    timer() {
      var _this = this;
      var time = window.setInterval(function() {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          window.clearInterval(time);
        } else {
          _this.seconds -= 1;
        }
        if(_this.seconds === 0 && _this.minutes === 0){
          Notify({ type: 'warning', message: '时间到！' });
          this.isTimeOut = true
          _this.$router.push({ name: 'timeout'})
        }
      }, 1000);
    },
    //获取待审核图片列表
    async getPicList(val) {
      let {data,status,message , pagination} = await listSelect(val)
      // console.log(data);
      if(status){
        if(this.currentPageAct == 1){
          this.chooseNum = 0
          this.picList = data
            for (let i = 0; i < this.picList.length; i++) {
              this.picList[i].isCheck = 0
              // this.picList[i].src = picPrefix + this.picList[i].indexpicInfo.picThumbW1080
              this.picList[i].src1 = picPrefix + this.picList[i].indexpicInfo.picThumbW1080
              this.picList[i].src = picPrefix + this.picList[i].indexpicInfo.picThumbW240H160
              this.images.push(this.picList[i].src1)
              if(this.picList[i].isCheck){
                this.chooseNum ++;
                this.picList[i].chooseNumber = this.chooseNum ;
              }
             }
        }else{
          for (let i = 0; i < data.length; i++) {
            data[i].src1 = picPrefix + data[i].indexpicInfo.picThumbW1080
            data[i].src = picPrefix + data[i].indexpicInfo.picThumbW240H160
            data[i].isCheck = 0
            if(data[i].isCheck){
              this.chooseNum ++;
              // data[i].chooseNumber = this.chooseNumberFlag ++;
              data[i].chooseNumber = this.chooseNum ;
            }
            this.picList.push(data[i])
            this.images.push(data[i].src1)
          }
          // this.chooseNum --;
        }
        this.allPicCount = pagination.total
        console.log(this.picList)
        console.log(this.chooseNum);

      }
    },
    //查看图片
    browsePic(item){
      
      this.show = true
      for (let i = 0; i < this.picList.length; i++) {
         if(item.id === this.picList[i].id){
            this.index = i
            console.log(this.index);
            console.log(this.picList[i].indexpicInfo.picThumbW1080);
            break;
         }       
      }
      console.log(this.images[this.index]);
    },
    browsePic1(item){
      this.show = true
      for (let i = 0; i < this.resultList.length; i++) {
         if(item.id === this.resultList[i].id){
            this.index1 = i
            break;
         }       
      }
    },
    async savePic(){
      let picID = []
      for (let i = 0; i < this.picList.length; i++) {
        if(this.picList[i].isCheck){
          picID.push(this.picList[i].pictureId)
          // this.picList[i].isCheck = 0
        }else {
          let val = {
            pictureArticleFilterTaskId: this.picList[i].pictureArticleFilterTaskId,
            pictureId : this.picList[i].pictureId
          }
          await unSelectPicture(val)
        }
      }
      console.log(picID);
      if(picID.length === 0){
        Notify({ type: 'warning', message: '请选择图片！' });
      }else{
        this.showdialog = true
           Dialog.confirm({
            title: '确认保存图片吗？',
            message: '',
          })
            .then(() => {
              let val = {
                pictureArticleFilterTaskId: this.$route.query.id,
                pictureIds: picID.join(',')
              }
              console.log(val);
              this.checkPicturesAsync(val)
              
            })
            .catch(() => {
              console.log('false');
            });
        }
    },
    async savePic1(){
      let picID = []
      for (let i = 0; i < this.picList.length; i++) {
        if(this.picList[i].isCheck){
          picID.push(this.picList[i].pictureId)
        }
      }
      if(picID.length === 0){
        Notify({ type: 'warning', message: '请选择图片！' });
      }else{
        this.showdialog = true
           Dialog.confirm({
            title: '确认保存图片吗？',
            message: '',
          })
            .then(() => {
              let val = {
                pictureArticleFilterTaskId: this.$route.query.id,
                pictureIds: picID.join(',')
              }
              console.log(val);
              this.checkPicturesAsync1(val)
              
            })
            .catch(() => {
              console.log('false');
            });
        }
    },
     //获取选入图片列表
    async checkPicturesAsync(val){
      let { status, data, message } = await checkPictures(val);
      if(status){
        Notify({ type: 'success', message: '保存成功！' });
        // for (let i = 0; i < this.picList.length; i++) {
          // this.picList[i].isCheck = 0
          // this.chooseNum = 0;
        // }
        // let val1 = {page:this.currentPageCheck - 1,pageSize:14,pictureArticleFilterTaskId :this.$route.query.id}
        // this.listCheckAsync(val1);
        // this.getTaskAsync();
      }else{
        Notify({ type: 'danger', message: '保存失败！' });
      }
    },
    async checkPicturesAsync1(val){
      let { status, data, message } = await checkPictures(val);
      if(status){
        Notify({ type: 'success', message: '保存成功！' });
        this.isResult = false
        let val1 = {page:this.currentPageCheck - 1,pageSize:14,pictureArticleFilterTaskId :this.$route.query.id}
        this.listCheckAsync(val1);
        let data = {id:this.$route.query.id,status:3}
        this.setTaskStatusAsync(data)
      }else{
        Notify({ type: 'danger', message: '保存失败！' });
      }
    },
    //选择图片
    choosePic(item) {
      item.isCheck = 1
      this.chooseNum ++;
      console.log(this.chooseNum);
      item.chooseNumber = this.chooseNum;
      console.log(item.chooseNumber);
      // this.chooseArr.push(item)
    },
    //取消选择
    deletePic(item) {
      item.isCheck = 0
      // console.log(item.chooseNumber);
      for (let i = 0; i < this.picList.length; i++) {
        if(item.chooseNumber < this.picList[i].chooseNumber){
          this.picList[i].chooseNumber --;
        }
      }
      this.chooseNum --;
    },
    // choosePic(item) {
    //   this.chooseNum ++;
    //   item.chooseNumber = 0
    //   item.isCheck = true
    //   for (let i = 0; i < this.picList.length; i++) {
    //     if(this.picList[i].isCheck){
    //       item.chooseNumber ++;
    //     }
    //   }
    // },
    // deletePic(item) {
    //   item.isCheck = false
    //   // console.log(item.chooseNumber);
    //   for (let i = 0; i < this.picList.length; i++) {
    //     if(item.chooseNumber < this.picList[i].chooseNumber){
    //       this.picList[i].chooseNumber --;
    //     }
    //   }
    // },
    async listCheckAsync(val){
      let { status, data, message,pagination } = await listCheck(val);
      if(status){
        if(this.currentPageCheck == 1){
          for (let i = 0; i < data.length; i++) {
            // data[i].src = picPrefix + data[i].indexpicInfo.picThumbW1080
            data[i].src1 = picPrefix + data[i].indexpicInfo.picThumbW1080
            data[i].src = picPrefix + data[i].indexpicInfo.picThumbW240H160
            this.images1.push(data[i].src1)
          }
          console.log(data);
          this.resultCount = pagination.total
          this.resultList = data
        }else {
          for (let i = 0; i < data.length; i++) {
            // data[i].src = picPrefix + data[i].indexpicInfo.picThumbW1080
            data[i].src1 = picPrefix + data[i].indexpicInfo.picThumbW1080
            data[i].src = picPrefix + data[i].indexpicInfo.picThumbW240H160
            this.images1.push(data[i].src1)
            this.resultList.push(data[i])
          }
        }
          console.log(data);
      }
    },
    //获取状态(审核/结束)
    async getTaskAsync() {
      
      let {status,data} = await getTask(this.$route.query.id);
      if(status){
        console.log(data.status);
        if(data.status === 2){
          this.isResult = true
        }else if(data.status === 3){
          this.isResult = false
          let val1 = {page:this.currentPageCheck - 1,pageSize:14,pictureArticleFilterTaskId :this.$route.query.id}
          this.listCheckAsync(val1);
        }
      }
      
    },
    async setTaskStatusAsync(val) {
      let { status, data, message } = await setTaskStatus(
        val
      );
    }
    //获取选入图片列表
    // async listCheckAsync(val){
      
    //   let { status, data, message,pagination } = await listCheck(val);
    //   if(status){
    //     for (let i = 0; i < data.length; i++) {
    //       // data[i].src = picPrefix + data[i].indexpicInfo.picThumbW1080
    //       data[i].src = 'http://cdp-local-web.test.routeryuncs.com/' + data[i].indexpicInfo.picThumbW1080
    //       this.images1.push(data[i].src)
    //     }
    //     console.log(data);
    //     this.resultCount = pagination.total
    //     this.resultList = data
    //   }
    // },
   

    
  },
  created() {
    
    this.transTime();
    this.timer()
    let val = {page:this.currentPageAct - 1,pageSize:14,pictureArticleFilterTaskId :this.$route.query.id}
    this.getPicList(val);
    
    this.setToken(this.$route.query.token)
    // console.log(this.$route.query.id)
    this.getTaskAsync();
    // this.setExpirationTime(this.$route.query.date)
    // this.setCreateUid(this.$route.query.createUid)

    // this.myPowersAsync()
    // setInterval(() => {
    //   let date =new Date()
    //   date = date.getTime(date)
    //   let cha = parseInt(this.$store.state.user.expirationTime) - date
    //   if(cha < 0){
    //     this.$router.push({ name: 'timeout'})
    //   }
    //   this.transTime(cha)

    // }, 1000);
  },
  mounted() {
    if (this._isMobile()) {
      // alert("手机端");
      this.isMobile = true;
    } else {
      // alert("pc端");
      this.isMobile = false;
    }
  },
  // destroyed() { //页面离开后销毁，防止切换路由后上一个页面监听scroll滚动事件会在新页面报错问题
  //   window.removeEventListener('scroll', this.getscroll())
  // }
};
</script>

<style lang="scss" scoped>
@import "./check.scss";
</style>